import { Injectable } from "@angular/core";

@Injectable()
export class Constants {
    constructor() { }

    public GUID_GENERATOR = function () {
        return ([1e7] as any + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        )
    }

    public IMS_HOST = 'https://api.digitalvault.cloud/IDM/ims';
 
    // public LOCAL_URL: string = "http://cepd-mobile-ui.azurewebsites.net/";
    //public LOCAL_URL: string = "http://localhost:9091/";
    //public BASE_URL: string = "https://cepu-web-api.azurewebsites.net/api/"   
    // public BASE_URL: string = "https://cepd-web-api.azurewebsites.net/api/"

    public BASE_URL: string = "https://cepdev2-web-api.azurewebsites.net/"
    public LEGACY_BASE_URL: string = "https://cepdev2-web-api.azurewebsites.net/"
    public NETCORE_BASE_URL: string = "https://cepdev2.mysmartequipment.com/bffsetupapi/"

    //public BASE_URL: string = "http://localhost:51032/api/"   
    //public IMS_URL: string = "https://api.digitalvault.cloud/IDM/ims";
    //public AUTHORIZATION_URL: string = "https://api.digitalvault.cloud/IDM/ims/connect/authorize";
    //public CLIENT_ID: string = "ConnectedEquipment.UI.Mobile";
    //public RESPONSE_TYPE: string = "code+id_token+token";
    //public CLIENT_SCOPES: string = "openid offline_access all_claims read write securityapi_all";

    public LOCAL_URL: string = "http://localhost:9091";
    public redirectUri = 'http://localhost:9091';
    public clientId = '0oazake9lCSF7d1Hw1d6';
    public scope = 'openid profile email';
    public issuer = 'https://jci-dev.oktapreview.com/oauth2/ausp8t9fv8mXIw2gp1d6';
    public responseType = 'code id_token token';
    public LogOutUrl: string = "https://jci-dev.oktapreview.com/oauth2/ausp8t9fv8mXIw2gp1d6/v1/logout"; //"http://localhost:9091";

    public DB_NAME: string = "csdcfa.db";
    public DB_LOCATION: string = "default";
    public GET_Langauges: string = "User/GetLangauges"
    public GET_TREE_STRUCTURE: string = "api/CsdHome/GetMobileCustomertreedata";
    public GET_FAVOURITE_CUSTOMERS: string = "api/CsdHome/GetFavouriteDetails";
    public GET_USER_DETAILS: string = "api/CsdHome/GetUserDetailsByUserNameList";
    public SAVE_FAVOURITE_CUSTOMERS: string = "api/CsdHome/SaveFavourite";
    public GET_DIAGNOSTIC_ALERTS: string = "api/CsdHome/MobileDiagnosticAlert";
    public GET_TREND_CHART: string = "api/CsdHome/GetTrendChart";
    public GET_HEALTH_DETAILS: string = "api/CsdHome/MobileHealthCheckForChillerData";
    public GET_POINTS_CATEGORY_NAME: string = "api/CsdHome/GetPointsCategoryName";
    public GET_GRID_DATA: string = "api/CsdHome/GetGridData";
    public GET_MOBILE_DATA: string = "api/CsdHome/GetDataForMobile";
    public GET_MANUAL_POINTS: string = "api/CsdHome/GetManualPoints";
    public POST_MANUAL_POINT_READINGS: string = "api/CsdHome/UploadLogReportData";
    public POST_BLOB: string = this.BASE_URL + "SendMail/PostBlob";
    public SEND_EMAIL: string = this.BASE_URL + "api/SendMail/SendMailUsingEvoPdf";
    public GET_LOG_REPORTS: string = "api/CsdHome/GetLogReportByAssetId";
    public SAVE_LOG_REPORTS_TO_DB: string = "api/CsdHome/StoreLogReportData";
    public GET_BRANCH_DETAILS: string = "api/Branch/GetBranchContactsByUsername";
    public GET_MOBILE_DATA_LOG_REPORT: string = "api/CsdHome/GetLogReportDataForMobile";
    public GET_AGREEMENT_CHECK_DETAILS: string = "api/CsdHome/GetAgreementCheckDetails";
    public GetDataSourceForUser: string = "api/User/GetDataSourceForUser";
    public GenerateLogReports: string = this.BASE_URL + "api/PDFApi/GenerateLogReports";
    public SendMail: string = this.BASE_URL + "api/SendMail/SendMail";
}


// WEBPACK FOOTER //
// ./src/commons/constants.ts